export default __webpack_public_path__ + "static/usage-step-1-a00de1bc1ac13286810c1aa2ed669eda.svg";